<template>
    <div style="height:100%;width:100%;">  
         
        <van-row
            type="flex"
            style="height:100%"
           v-if="root.device!='phone'"
           :class="[root.device=='ipad'&&'mipad']"
            >           
            <van-col flex="1">
                <van-row
                    type='flex'
                    rank='y'
                    style="height:100%;"
                >
                    <van-col
                        style="margin-top:-0.626vw"
                        flex="1"
                    >
                        <div class='wrapper'>
                            <cusbox txt="本月20家退货回大仓最多店铺">
                                <div class="tablewrapper">
                                    <itemlist
                                        :count='5'
                                        :columns='columns1'
                                        :data='data1'
                                        v-if="mostShopsReturnGoodsShow"
                                    />
                                <dv-loading v-else>Loading...</dv-loading>
                                </div>
                            </cusbox>
                        </div>
                    </van-col>
                    <van-col flex="2.4">
                        <div class='wrapper'>
                            <cusbox txt="本月商品销量 BOTTOM50">
                                <div class="tablewrapper">
                                    <itemlist
                                        :count='10'
                                        :columns='columns2'
                                        :data='data2'
                                        v-if="saleRankingListASCGoodsShow"
                                    >
                                        <template
                                            slot='img'
                                            slot-scope="{data}"
                                        >
                                            <img
                                                class="icon"
                                                :src='data.imageUrl'
                                            >
                                        </template>
                                    </itemlist>
                                    <dv-loading v-else>Loading...</dv-loading>
                                </div>
                            </cusbox>
                        </div>
                    </van-col>
                </van-row>
            </van-col>
            <van-col flex="1">
                <div class='wrapper'>
                    <cusbox txt="50款退货频次最高的商品">
                        <div class="tablewrapper">
                            <itemlist
                                :count='17'
                                :columns='columns3'
                                :data='data3'
                                 v-if="highestReturnFrequencyGoodsShow"
                            >
                                <template
                                    slot='img'
                                    slot-scope="{data}"
                                >
                                    <img
                                        class="icon"
                                        :src='data.pics'
                                    >
                                </template>
                            </itemlist>
                            <dv-loading v-else>Loading...</dv-loading>
                        </div>
                    </cusbox>
                </div>
            </van-col>
            <van-col flex="1">
                <van-row
                    type='flex'
                    rank='y'
                    style="height:100%;"
                >
                    <van-col
                        style="margin-top:-0.626vw"
                        flex="1"
                    >
                        <div class='wrapper'>
                            <cusbox txt="本月店铺拉新 BOTTOM20">
                                <div class="tablewrapper">
                                    <itemlist
                                        :count='5'
                                        :columns='columns4'
                                        :data='data4'
                                         v-if="storeNewMembersShow"
                                    />
                                    <dv-loading v-else>Loading...</dv-loading>
                                </div>
                            </cusbox>
                        </div>
                    </van-col>
                    <van-col flex="2">
                        <div class='wrapper'>
                            <cusbox txt="商品正价销量数 BOTTOM50">
                                <div class="tablewrapper">
                                    <itemlist
                                        :count='10'
                                        :columns='columns5'
                                        :data='data5'
                                        v-if="saleAtRegularPriceShow"
                                    >
                                        <template
                                            slot='img'
                                            slot-scope="{data}"
                                        >
                                            <img
                                                class="icon"
                                                :src='data.pics'
                                            >
                                        </template>
                                    </itemlist>
                                    <dv-loading v-else>Loading...</dv-loading>
                                </div>
                            </cusbox>
                        </div>
                    </van-col>
                </van-row>
            </van-col>
        </van-row>


      
 <mobile class="device_phone ppd notransform" v-else>
          
          <div class="moblieline ">
                
                      <cusbox txt="本月20家退货回大仓最多店铺">                          
                          <div class="tablewrapper">
                              <itemlist
                                  :count='5'
                                  :columns='columns1'
                                  :data='data1'
                                  v-if="mostShopsReturnGoodsShow"
                              />
                              <dv-loading v-else>Loading...</dv-loading>
                          </div>
                      </cusbox>
                 
          </div>
            <div class="moblieline h450">
                 
                       <cusbox txt="本月商品销量 BOTTOM50">
                                <div class="tablewrapper">
                                    <itemlist
                                        :count='10'
                                        :columns='columns22'
                                        :data='data2'
                                        v-if="saleRankingListASCGoodsShow"
                                    >
                                        <template
                                            slot='img'
                                            slot-scope="{data}"
                                        >
                                            <img
                                                class="icon"
                                                :src='data.imageUrl'
                                            >
                                        </template>
                                    </itemlist>
                                    <dv-loading v-else>Loading...</dv-loading>
                                </div>
                            </cusbox>
                
          </div>
           <div class="moblieline h800">
            
                      <cusbox txt="50款退货频次最高的商品">
                        <div class="tablewrapper">
                            <itemlist
                                :count='17'
                                :columns='columns33'
                                :data='data3'
                                v-if="highestReturnFrequencyGoodsShow"
                            >
                                <template
                                    slot='img'
                                    slot-scope="{data}"
                                >
                                    <img
                                        class="icon"
                                        :src='data.pics'
                                    >
                                </template>
                            </itemlist>
                            <dv-loading v-else>Loading...</dv-loading>
                        </div>
                    </cusbox>
                 
          </div>
                     <div class="moblieline">
            
                      <cusbox txt="本月店铺拉新 BOTTOM20">
                                <div class="tablewrapper">
                                    <itemlist
                                        :count='5'
                                        :columns='columns44'
                                        :data='data4'
                                        v-if="storeNewMembersShow"
                                    />
                                    <dv-loading v-else>Loading...</dv-loading>
                                </div>
                            </cusbox>
                 
          </div>
           <div class="moblieline h450">
            
                  <cusbox txt="商品正价销量数 BOTTOM50">
                                <div class="tablewrapper">
                                    <itemlist
                                        :count='10'
                                        :columns='columns55'
                                        :data='data5'
                                        v-if="saleAtRegularPriceShow"
                                    >
                                        <template
                                            slot='img'
                                            slot-scope="{data}"
                                        >
                                            <img
                                                class="icon"
                                                :src='data.pics'
                                            >
                                        </template>
                                    </itemlist>
                                    <dv-loading v-else>Loading...</dv-loading>
                                </div>
                            </cusbox>
                 
          </div>
        </mobile>
    </div>
</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import cusbox from "@/components/vip/cusbox";
import itemlist from "@/components/cuscom/itemlist";
import mobile from "../common/mobile.vue";
export default {
  
  components: {
    cusbox,
    itemlist,
    layout,
    mobile
  },
  inject:['root'],
  data() {
    return {     
     
      columns1: [
        {
          title: "排名",
          key: "rank",
          align: "center"
          //   width: "5vw"
        },
        {
          title: "店铺",
          key: "shopName",
           align: "center"
        },
        {
          title: "上月退回件数",
          key: "lastMonthReturn",
          align: "center"
        },
        {
          title: "本月退回件数",
          key: "thisMonthReturn",
          align: "center"
        }
      ],
      columns22:[
         {
          title: "排名",
          key: "rank",
          align: "center"
          //   width: "2.5vw"
        },
        {
          title: "图片",
          key: "imageUrl",
            // width: "1vw",
          slot: "img",
           align: "center"
        },
        {
          title: "销量",
          key: "sales",
           align: "center"
          //   width: "3vw"
        },
        {
          title: "支付买家数",
          key: "buyerNumber",
          align: "center"
        },
        {
          title: "支付金额",
          key: "saleVolume",
          align: "center"
        }
      
      ],
      columns2: [
        {
          title: "排名",
          key: "rank",
          align: "center",
          width: "2.5vw"
        },
        {
          title: "图片",
          key: "imageUrl",
            width: "2.5vw",
          slot: "img",
           align: "center"
        },
        {
          title: "货号",
          key: "itemId",
            // width: "6.5vw",
             align: "center"
        },
        {
          title: "品类",
          key: "goodsClass",
          width: "5vw",
           align: "center"
        },
        {
          title: "销量",
          key: "sales",
            width: "3vw",
                 align: "center"
        },
        {
          title: "支付买家数",
          key: "buyerNumber",
          align: "center",
             width: "5vw"
        },
        {
          title: "支付金额",
          key: "saleVolume",
          align: "center"
        },
        {
          title: "库存",
          key: "stock",
           align: "center"
        }
      ],
      columns3: [
        {
          title: "排名",
          key: "rank",
          align: "center",
            width: "2.5vw"
        },
        {
          title: "图片",
          key: "pics",
          align: "center",
           width: "3vw",
          slot: "img"
        },
        {
          title: "货号",
          key: "goodsNo",
          align: "center",
           width: "6vw",
        },
        {
          title: "品类",
          key: "rootcategory",
          align: "center",
          //   width: "4vw"
        },
        {
          title: "退款次数",
          key: "quantity",
          align: "center",
        },
        {
          title: "退款总金额",
          key: "unitprice",
          align: "center",
        }
      ],
      columns33: [
        {
          title: "排名",
          key: "rank",
          align: "center",
         
        },
        {
          title: "图片",
          key: "pics",
          align: "center",
         
          slot: "img"
        },
        {
          title: "货号",
          key: "goodsNo",
          align: "center",        
        },
        {
          title: "品类",
          key: "rootcategory",
          align: "center",
          //   width: "4vw"
        },
        {
          title: "退款次数",
          key: "quantity",
          align: "center",
        },
        {
          title: "退款总金额",
          key: "unitprice",
          align: "center",
        }
      ],
      columns44: [
        {
          title: "排名",
          key: "rank",
          align: "center",
        
        },
        {
          title: "店铺",
          key: "shopName",
          align: "center",
         
        },
        {
          title: "本月拉新数",
          key: "thisMonthNewMember",
          align: "center"
        },
        {
          title: "会员总数",
          key: "totalMembers",
          align: "center"
        },
        {
          title: "上月拉新数",
          key: "lastMonthNewMember",
          align: "center"
        }
      ],
      columns4: [
        {
          title: "排名",
          key: "rank",
          align: "center",
          width: "4vw"
        },
        {
          title: "店铺",
          key: "shopName",
          width: "10vw",
           align: "center"
        },
        {
          title: "本月拉新数",
          key: "thisMonthNewMember",
          align: "center"
        },
        {
          title: "会员总数",
          key: "totalMembers",
          align: "center"
        },
        {
          title: "上月拉新数",
          key: "lastMonthNewMember",
          align: "center"
        }
      ],
            columns55: [
        {
          title: "排名",
          key: "rank",
          align: "center",
      
        },
        {
          title: "图片",
          key: "pics",
        align: "center",
          slot: "img"
        },
      
        {
          title: "吊牌价",
          key: "price",
       align: "center",
        },
        {
          title: "正价销售",
          key: "regularPrice",
          align: "center"
        },
        {
          title: "总销售",
          key: "totalSale",
           align: "center"
        }
      ],
      columns5: [
        {
          title: "排名",
          key: "rank",
          align: "center",
          width: "2.5vw"
        },
        {
          title: "图片",
          key: "pics",
          width: "3vw",
          slot: "img",
           align: "center"
        },
        {
          title: "货号",
          key: "goodsNo",
           align: "center"
        },
        {
          title: "品类",
          key: "rootcategory",
          width: "4vw",
           align: "center"
        },
        {
          title: "吊牌价",
          key: "price",
          width: "3vw",
           align: "center"
        },
        {
          title: "正价销售",
          key: "regularPrice",
          align: "center"
        },
        {
          title: "总销售",
          key: "totalSale",
           align: "center"
        }
      ],
      data1: [],
      mostShopsReturnGoodsShow:false,
      data2: [],
      saleRankingListASCGoodsShow:false,
      data3: [],
      highestReturnFrequencyGoodsShow:false,
      data4: [],
      storeNewMembersShow:false,
      data5: [],
      saleAtRegularPriceShow:false,
      api: this.$apis["bottom"]
    };
  },
  mounted() {
    let that= this
    //本月20家退货回大仓最多店铺
    this.api.mostShopsReturnGoods().then(res => {
      this.mostShopsReturnGoodsShow = true
      setTimeout(function(){that.data1 = res.data.list;},0)
      
    });
    //本月商品销量 BOTTOM50
    this.api.saleRankingListASCGoods().then(res => {
      this.saleRankingListASCGoodsShow = true;
      setTimeout(function(){that.data2 = res.data.list;},0)
      
    });
    //50款退货频次最高排名
    this.api.highestReturnFrequencyGoods().then(res => {
      this.highestReturnFrequencyGoodsShow = true
      setTimeout(function(){that.data3 = res.data.list;},0)
    });
    //本月店铺拉新 BOTTOM20
    this.api.storeNewMembers().then(res => {
      this.storeNewMembersShow = true
      setTimeout(function(){that.data4 = res.data.list;},0)
    });
    //正价销售bottom50
    this.api.saleAtRegularPrice().then(res => {
      this.saleAtRegularPriceShow = true
      setTimeout(function(){that.data5 = res.data.list;},0)
    });
  },
  methods: {
    
  }
};
</script>


<style lang="scss" scoped>
.tablewrapper_mobile {
  height: 40vw;
}
</style>